/*eslint-disable multiline-ternary */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import 'react-toastify/dist/ReactToastify.css';
import AddNewMedia from './AddNewMedia';
import { axiosInstance } from '../../../../src/api/axios';
import CookiesService from '../../shared/CookiesService';
import APIEndpoints from '../../../Admin/api/APIEndpoints';
import CustomClientError from '../../errorhandling/CustomClientError';
import Header from '../../components/common/Header/Header';
import ConfigSocialMediaSkeleton from './ConfigSocialMediaSkeleton';
import { ALL_DATA } from '../../../constants/index';
import ToastMessage from '../common/ToastMessage';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import MasterPermissions from '../../api/MasterPermissions';

const ConfigureSocialMedia = (props) => {
  const navigate = useNavigate();
  const [socialMedia, setSocialMedia] = useState({ medias: [] });
  const [loader, setLoader] = useState(false);
  const [disabledValue, setdisabledValue] = useState(true);
  const [clientError, setClientError] = useState(false);
  const [isAPIFailed, setIsAPIFailed] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);
  const { t } = useTranslation();
  const bearerToken = CookiesService.get('loginToken');

  function changedData(apiData) {
    apiData.map((apiElement) => {
      ALL_DATA.map((objElement) => {
        if (apiElement.MediaType === objElement.MediaType) {
          objElement.OID = apiElement.OID;
          objElement.MediaType = apiElement.MediaType;
          objElement.URL = apiElement.URL;
        } else {
          console.log('Nothing to merge');
        }
      });
    });
    return ALL_DATA;
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoader(true);
    const getSocialMedias = async () => {
      return await axiosInstance.get(APIEndpoints.getSocialMediaLinks(), {
        headers: { Authorization: bearerToken },
      });
    };
    (async () => {
      try {
        const mediaLinks = await getSocialMedias();
        const data = mediaLinks.data.Response.SocialMediaLinks;
        const result = changedData(data);
        setSocialMedia({
          medias: result,
        });
        setIsAPIFailed(false);
        setIsNotFound(false);
      } catch (err) {
        setClientError(true);
        if (err.toString().includes('404')) {
          setIsNotFound(true);
        }
        setIsAPIFailed(true);
        console.log(err);
      } finally {
        setLoader(false);
      }
    })();
  }, []);

  const onChangeMediaLink = (mediaUrl, mediaIndex, isUrlValid) => {
    if (isUrlValid === false && mediaUrl != '') {
      setdisabledValue(true);
    } else {
      setdisabledValue(false);
    }
    const newMediaData = [...socialMedia.medias];
    newMediaData[mediaIndex].URL = mediaUrl;
    setSocialMedia({
      medias: newMediaData,
    });
  };

  const updateSocialMediaLink = async (socialmedialinks) => {
    socialmedialinks.map((link) => {
      if (
        !link.URL.indexOf('https://') == 0 &&
        !link.URL.indexOf('http://') == 0 &&
        link.URL != ''
      ) {
        const urlVal = 'https://';
        link.URL = urlVal + link.URL;
      }
    });
    return await axiosInstance.post(
      APIEndpoints.getSocialMediaLinks(),
      { SocialMediaLinks: socialmedialinks },
      { headers: { Authorization: bearerToken } },
    );
  };

  const onSaveSocialMediaLinks = async () => {
    const updatedMediaLinks = socialMedia.medias;
    try {
      setLoader(true);
      const updatedSocialMediaLinks = await updateSocialMediaLink(
        updatedMediaLinks,
      );
      const mediasResponse =
        updatedSocialMediaLinks.data.Response.SocialMediaLinks;
      if (mediasResponse) {
        toast.success(
          <ToastMessage
            type="success"
            subTitle="Social Media saved successfully"
          />,
          setdisabledValue(true),
        );
      }
    } catch (err) {
      console.log(err);
      toast.error(
        <ToastMessage
          type="error"
          subTitle="Failed to save social media links."
        />,
      );
    } finally {
      setLoader(false);
    }
  };

  const handleCancel = () => {
    navigate('/admin/admin-dashboard');
  };

  return (
    <>
      <Container fluid className="claims-details">
        <Header
          linkTo={'/admin/admin-dashboard'}
          header={t('admin.pages.medialinks.module')}
        />

        {isAPIFailed && !loader ? (
          <div className="container-offset">
            {isNotFound ? (
              <CustomClientError
                ErrorHeading="No Social Media found!"
                ErrorMessage="The selected Member does not have any Social Media."
              />
            ) : (
              <CustomClientError
                ErrorHeading="Something went wrong with request!"
                ErrorMessage="Please try again."
              />
            )}
          </div>
        ) : (
          <>
            {loader
              ? [1, 2, 3, 4, 5, 6].map((item) => (
                  <div key={item} className="link-card-socialmedia">
                    <ConfigSocialMediaSkeleton />
                  </div>
                ))
              : socialMedia.medias.length > 0 &&
                socialMedia.medias.map((item, index) => (
                  <Row key={index} className="link-card-socialmedia">
                    <Col>
                      <AddNewMedia
                        key={item.OID}
                        media={item}
                        index={index}
                        onChangeMediaLink={onChangeMediaLink}
                        allmedias={socialMedia.medias}
                        disable={
                          !MasterPermissions.CheckPermission(
                            'Edit Configure Social Media',
                          )
                        }
                      />
                    </Col>
                  </Row>
                ))}

            {socialMedia.medias.length > 0 ? (
              <Row>
                <Col className="float-right text-right">
                  <GenericButton variant="link" onClick={handleCancel}>
                    <b>{t('label_cancel')}</b>
                  </GenericButton>
                  <GenericButton
                    variant="primary"
                    type="submit"
                    disable={
                      disabledValue ||
                      !MasterPermissions.CheckPermission(
                        'Edit Configure Social Media',
                      )
                    }
                    buttonDisabled={
                      disabledValue ||
                      !MasterPermissions.CheckPermission(
                        'Edit Configure Social Media',
                      )
                    }
                    onClick={onSaveSocialMediaLinks}
                  >
                    {t('label_save')}
                  </GenericButton>
                </Col>
              </Row>
            ) : null}
          </>
        )}
        {/*{!loader && clientError &&
          < ClientError />} */}
      </Container>
      <ToastContainer
        position="top-center"
        className="toastcontainer"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};
export default ConfigureSocialMedia;
